module.exports = __webpack_public_path__ + "static-portal/img/PSM.199a9f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PSM.jpg
// module id = Ib6/
// module chunks = 4